export default function titleise(token: string) {
    return token.split(" ").map(word => word[0].toUpperCase() + word.slice(1)).join(" ")
}
